module.exports = __webpack_public_path__ + "media/reference1.211bc33b.mp3";